<template>
  <v-row class="pa-2">
    <!-- COLUMNA IZQUIERDA: CONFIGURACIÓN -->
    <v-col cols="12" md="4">
      <v-card class="pgs-modern-card d-flex flex-column h-100" elevation="0">
        <div class="px-5 pt-5 pb-2 border-bottom">
          <ModuleHeader>Cerrar/Aperturar el campo en rangos de Fechas</ModuleHeader>
        </div>

        <v-card-text class="flex-grow-1">
          <div class="mb-4 custom-datepicker">
            <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">
              Selecciona una fecha inicial
            </div>
            <Datepicker @selected="selectDate" :value="input_date.format('MM/DD/YYYY')" input-class="modern-input">
            </Datepicker>
          </div>

          <div class="mb-6 custom-datepicker">
            <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">
              Selecciona una fecha final
            </div>
            <Datepicker @selected="selectDateFinal" :disabled-dates="disableDates"
              :value="input_date_final.format('MM/DD/YYYY')" input-class="modern-input"></Datepicker>
          </div>

          <v-divider class="mb-5"></v-divider>

          <ModuleHeader>Opciones del Campo</ModuleHeader>
          <v-select label="Estatus" v-model="status" :items="[
            { value: 1, text: 'Abierto' },
            { value: 2, text: 'Cerrado' },
          ]" outlined dense color="primary" class="mt-4"></v-select>

          <div v-if="status == 1" class="mb-4">
            <v-switch v-model="customHour" label="Usar horas de apertura y cierre personalizadas" color="primary" inset
              hide-details></v-switch>
          </div>

          <v-row v-if="customHour && status == 1">
            <v-col cols="6">
              <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Hora Inicial
              </div>
              <div class="modern-timepicker">
                <datetime type="time" input-id="iniTime" :min-datetime="minDate" :max-datetime="maxDate"
                  v-model="HoraInicial" :auto="false" :format="{ hour: 'numeric', minute: '2-digit' }" :minute-step="10"
                  input-class="modern-input"></datetime>
              </div>
            </v-col>
            <v-col cols="6">
              <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">Hora Final</div>
              <div class="modern-timepicker">
                <datetime type="time" input-id="endTime" v-model="HoraFinal" :minute-step="10" :auto="false"
                  :min-datetime="initialHour" :max-datetime="maxDate" input-class="modern-input"></datetime>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="pa-4 bg-grey-lighten-4" style="border-bottom-left-radius: 16px; border-bottom-right-radius: 16px;">
          <v-btn @click="sendData" color="primary" elevation="0" block large
            class="text-none font-weight-bold rounded-lg">
            Aplicar Configuración
          </v-btn>
        </div>
      </v-card>
    </v-col>

    <!-- COLUMNA DERECHA: REGLAS -->
    <v-col cols="12" md="8">
      <v-card class="pgs-modern-card d-flex flex-column h-100" elevation="0">

        <div class="px-5 pt-5 pb-2 border-bottom">
          <ModuleHeader>Filtro y Departamento</ModuleHeader>
        </div>

        <v-card-text>
          <div class="mb-5">
            <selectDepartment></selectDepartment>
          </div>

          <v-divider class="mb-5"></v-divider>

          <ModuleHeader>Consulta de Reglas Vigentes</ModuleHeader>
          <div class="custom-datepicker mt-4 mb-6" style="max-width: 300px;">
            <div class="text-caption font-weight-bold grey--text text--darken-1 text-uppercase mb-2">
              Selecciona una fecha para consultar
            </div>
            <Datepicker @selected="selectDateSearch" :value="input_date_search.format('MM/DD/YYYY')"
              input-class="modern-input"></Datepicker>
          </div>

          <!-- LISTADO DE REGLAS -->
          <div v-if="daysRules && daysRules.length > 0" class="rule-list">
            <v-card v-for="(rules, index) in daysRules" :key="index" outlined class="mb-3 rounded-lg hover-lift">
              <div class="d-flex align-center justify-space-between pa-4">

                <div class="d-flex align-center">
                  <div class="mr-4">
                    <v-avatar :color="rules.status === 'Abierto' ? 'green lighten-5' : 'red lighten-5'" size="48"
                      class="rounded-lg">
                      <v-icon :color="rules.status === 'Abierto' ? 'green darken-2' : 'red darken-2'">
                        {{ rules.status === 'Abierto' ? 'mdi-door-open' : 'mdi-door-closed' }}
                      </v-icon>
                    </v-avatar>
                  </div>
                  <div>
                    <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1">
                      {{ rules.dateFormat }}
                    </div>
                    <div class="d-flex align-center">
                      <v-chip :color="rules.status === 'Abierto' ? 'green' : 'red'" text-color="white" x-small
                        class="font-weight-bold px-2 mr-3">
                        {{ rules.status }}
                      </v-chip>

                      <template v-if="rules.customHoras">
                        <v-chip color="teal" outlined x-small class="font-weight-bold px-2">
                          <v-icon left x-small>mdi-clock-outline</v-icon>
                          {{ rules.data.Abre }} - {{ rules.data.Cierra }}
                        </v-chip>
                      </template>
                    </div>
                  </div>
                </div>

                <div>
                  <v-btn icon color="error" @click="deleteRule(rules.date)" title="Eliminar Regla">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </div>

          <div v-else class="d-flex flex-column align-center justify-center text-center pa-10"
            style="min-height: 250px;">
            <v-icon size="64" color="grey lighten-3" class="mb-4">mdi-calendar-remove-outline</v-icon>
            <h3 class="font-weight-medium grey--text text--darken-1">Sin reglas configuradas</h3>
            <p class="text-caption grey--text mt-2">No hay reglas vigentes para la fecha seleccionada.</p>
          </div>

        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style>
/* Scoped o estilos globales para los datepickers/inputs en esta vista */
.pgs-modern-card {
  background-color: white;
  border-radius: 16px !important;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

.bg-grey-lighten-4 {
  background-color: #f8fafc !important;
}

.hover-lift {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
  border-color: #cbd5e1;
}

/* Sobreescribiendo estilos feos de input que existian */
.modern-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f8fafc;
  color: #334155;
  font-size: 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;
}

.modern-input:focus {
  border-color: var(--v-primary-base, #1976D2);
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
  background-color: white;
}
</style>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "configDays",
  components: {
    Datepicker,
  },
  props: [],
  data() {
    return {
      MainDepartamento: "",
      input_date: moment(),
      input_date_final: moment(),
      input_date_search: moment(),
      customHour: false,
      status: 1,
      daysRules: [],
      HoraInicial: "",
      HoraFinal: "",
      days: {
        lun: false,
        mar: false,
        mie: false,
        jue: false,
        vie: false,
        sab: false,
        dom: false,
      },
      minDate: "06:00",
      maxDate: "18:01",
    };
  },
  methods: {
    init() { },
    selectDateSearch(arg) {
      this.input_date_search = moment(arg);
      this.getDaysRules();
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    validate() {
      let valid = true;
      if (this.status == 1 && this.customHour) {
        if (this.HoraFinal === "" || this.HoraInicial === "") {
          valid = false;
        }
      }
      return valid;
    },
    sendData() {
      if (this.validate()) {
        let data = {
          date: this.input_date.format("YYYY-MM-DD"),
          endDate: this.input_date_final.format("YYYY-MM-DD"),
          open: this.status == 1 ? true : false,
        };
        data.Departamento = this.MainDepartamento;
        if (this.customHour) {
          data.customsHours = true;
          data.times = {
            abre: this.Hour.inicial.format("HH:mm:ss"),
            cierra: this.Hour.final.format("HH:mm:ss"),
          };
        }

        this.$swal({
          title: "Atención",
          text: "Estas apunto de modificar las propiedades de la fecha seleccionada",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Continuar",
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: async () => {
            //var addReserva = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-crearReglaDia');
            return await this.$store.getters.getFirebaseApp.fba
              .call("RVA-Configuracion-crearReglaDia", data)
              .then(function (result) {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              this.$swal("Guardado", "La Fecha fue modificada", "success");
              this.$emit("changeIndex");
            } else {
              this.$swal(
                "Error saving reservation",
                result.value.data.error,
                "error"
              );
            }
          }
        });
      } else {
        this.$swal(
          "¡¡Las fechas de Apertura y Cierre no pueden ir vacias",
          "",
          "error"
        );
      }
    },
    deleteRule(fecha) {
      let data = {
        date: fecha,
      };
      data.Departamento = this.MainDepartamento;

      this.$swal({
        title: "¿Deseas eliminar esta regla?",
        text: "Se eliminar la regla permanentemente",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          //var deleteRule = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-eliminarReglaDia');
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Configuracion-eliminarReglaDia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Regla Eliminada",
              "La regla se elimino correctamente",
              "success"
            );
            this.$emit("changeIndex");
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    async getDaysRules() {
      let actual = this.input_date_search.format("YYYY-MM-DD");
      const database = this.$store.getters.getFirebaseApp.database;
      let snapshot = await database.queryBuilder(
        "RVA/Configuracion/" +
        this.MainDepartamento +
        "/Calendario/Fechas_Especiales",
        [database.orderByKey(), database.startAt(actual)]
      );
      if (snapshot.exists()) {
        this.daysRules = [];
        let arrayCalendar = Object.entries(snapshot.val());
        arrayCalendar.forEach((element) => {
          this.daysRules.push({
            date: element[0],
            data: element[1],
            dateFormat: moment(element[0], "YYYY-MM-DD").format("DD-MMM-YYYY"),
            status: !element[1] ? "Cerrado" : "Abierto",
            customHoras: element[1].Abre ? true : false,
          });
        });
      } else {
        this.daysRules = [];
      }
    },
  },
  computed: {
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    initialHour() {
      if (this.HoraInicial === "") {
        return this.minDate;
      } else {
        let hour = new moment(this.HoraInicial);
        //hour.add(10, 'minutes')
        return hour.format("HH:mm");
      }
    },
    Hour() {
      let ini = moment(this.HoraInicial);
      let fini = moment(this.HoraFinal);

      return { inicial: ini, final: fini };
    },
  },
  watch: {
    HoraInicial: function () {
      this.HoraFinal = "";
    },
  },
  mounted() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    //this.getDaysRules();
  },
  created() { },
};
</script>
